import { z } from 'zod';

//* device type
export const locationTrackingDeviceTypeSchema = z.enum(['phone', 'IoT_GPS', 'whatsapp']);
export type LocationTrackingDeviceType = z.infer<typeof locationTrackingDeviceTypeSchema>;

//* device info
export const locationTrackingDeviceSchema = z.object({
  /** the device type in which we're tracking the user activity:
   * - `phone` = means it's coming from the phone ... this is the `primary` source of activity tracking.
   * - `IoT_GPS` = means it's coming from Hardware GPS tracking ... like the ones in in trucks.
   * - `whatsapp` = a location pin / Maps link the driver shared over WhatsApp
   *   (the app-less-driver path — see `docs/ai/whatsapp-agent.md`). Battery
   *   fields are zeroed for these rows.
   */
  type: locationTrackingDeviceTypeSchema,

  /** the device battery level ranging from `1` to `0`.
   *
   * - `1` = means 100%
   * - `0.5` = means 50%
   * -  `...etc`
   * - `0` = means 0%
   */
  betterLevel: z.coerce.number(),

  /** this indicates if the current device is currently being charged or not */
  isBatteryCharging: z.boolean(),
});
export type LocationTrackingDevice = z.infer<typeof locationTrackingDeviceSchema>;
